import type { Component } from 'vue';
import { EffectType } from '@/typings/customilyElements/imageEffectType';

type EffectComponentLoader = () => Promise<{ default: Component }>;

const EFFECT_COMPONENT_MAP: Partial<Record<EffectType, EffectComponentLoader>> = {
    [EffectType.OPENAI_IMAGE_EDIT]: () =>
        import(
            '@/components/DesignStudio/ImageEffectsProperties/components/list/item/edit/forms/OpenAI/OpenAIImageEditForm.vue'
        ),
    [EffectType.OPENAI_IMAGE_EDIT_OPENROUTER]: () =>
        import(
            '@/components/DesignStudio/ImageEffectsProperties/components/list/item/edit/forms/OpenAI/OpenAIImageEditOpenRouterForm.vue'
        ),
    [EffectType.GEMINI_IMAGE_EDIT]: () =>
        import(
            '@/components/DesignStudio/ImageEffectsProperties/components/list/item/edit/forms/Gemini/GeminiImageEditForm.vue'
        ),
    [EffectType.GEMINI_IMAGE_EDIT_OPENROUTER]: () =>
        import(
            '@/components/DesignStudio/ImageEffectsProperties/components/list/item/edit/forms/Gemini/GeminiImageEditOpenRouterForm.vue'
        ),
    [EffectType.GEMINI_IMAGE_TRANSFER_STYLE_OPENROUTER]: () =>
        import(
            '@/components/DesignStudio/ImageEffectsProperties/components/list/item/edit/forms/Gemini/GeminiStyleTransferOpenRouterForm.vue'
        ),
    [EffectType.CUTOUT_PRO_RMBG]: () =>
        import(
            '@/components/DesignStudio/ImageEffectsProperties/components/list/item/edit/forms/CutoutPro/CutoutProRmbgForm.vue'
        ),
    [EffectType.CUTOUT_PRO_FACE_CUT_OUT]: () =>
        import(
            '@/components/DesignStudio/ImageEffectsProperties/components/list/item/edit/forms/CutoutPro/CutoutProFaceCutOutForm.vue'
        ),
    [EffectType.CUTOUT_PRO_CARTOON_SELFIE]: () =>
        import(
            '@/components/DesignStudio/ImageEffectsProperties/components/list/item/edit/forms/CutoutPro/CutoutProCartoonSelfieForm.vue'
        ),
    [EffectType.REMOVE_BG]: () =>
        import(
            '@/components/DesignStudio/ImageEffectsProperties/components/list/item/edit/forms/RemoveBg/RemoveBgForm.vue'
        ),
    [EffectType.PICWISH_UPSCALE]: () =>
        import(
            '@/components/DesignStudio/ImageEffectsProperties/components/list/item/edit/forms/PichWish/PichWishForm.vue'
        ),
    [EffectType.CUSTOMILY_COLOR_TO_ALPHA]: () =>
        import(
            '@/components/DesignStudio/ImageEffectsProperties/components/list/item/edit/forms/Customily/ColorToAlphaForm.vue'
        ),
    [EffectType.CUSTOMILY_FACE_CUT_OUT]: () =>
        import(
            '@/components/DesignStudio/ImageEffectsProperties/components/list/item/edit/forms/Customily/CustomilyFaceCutOutForm.vue'
        ),
    [EffectType.GEMINI_TEXT_TO_IMAGE]: () =>
        import(
            '@/components/DesignStudio/ImageEffectsProperties/components/list/item/edit/forms/Gemini/GeminiTextToImageForm.vue'
        ),
    [EffectType.OPENAI_TEXT_TO_IMAGE]: () =>
        import(
            '@/components/DesignStudio/ImageEffectsProperties/components/list/item/edit/forms/OpenAI/OpenAITextToImageForm.vue'
        ),
    [EffectType.OPENROUTER_TEXT_TO_IMAGE]: () =>
        import(
            '@/components/DesignStudio/ImageEffectsProperties/components/list/item/edit/forms/OpenRouter/OpenRouterTextToImageForm.vue'
        )
};

export async function getEffectComponent(type: EffectType): Promise<Component | null> {
    const componentLoader = EFFECT_COMPONENT_MAP[type];
    if (!componentLoader) {
        return null;
    }
    try {
        const module = await componentLoader();
        return module.default;
    } catch (error) {
        console.error(`[componentMapper] Failed to load component for effect type ${type}:`, error);
        return null;
    }
}
